export const MANAGER_BOT = 'https://t.me/paygosupport_bot'
